import contract from '@mailobj-browser/front/js/contracts/contract.js'
import mains from './mains/mains.js'
import out from './out/out.js'

import './common/permissions/permissions.js'

/* test */

export default contract({
  mains,
  out
})
